"use client";

import { PortfolioEstateCard } from "@/components/portfolio/all-estate-overview/PortfolioEstateCard";
import { useLanguage } from "@/context/LanguageContext";
import type { ClientEstate, EstateStats } from "@/types";

type PortfolioEstateGridProps = {
  estates: ClientEstate[];
  estateStats: Record<string, EstateStats>;
  isPredictionView: boolean;
  onSelectEstate: (estate: ClientEstate) => void;
};

export function PortfolioEstateGrid({
  estates,
  estateStats,
  isPredictionView,
  onSelectEstate,
}: PortfolioEstateGridProps) {
  const { language } = useLanguage();
  const copy = {
    cs: {
      properties: "Nemovitosti v portfoliu",
      description:
        "Výsledky jednotlivých nemovitostí. Kliknutím otevřete jejich detail.",
      forecast: "Včetně predikce",
      actual: "Aktuální průběh roku",
    },
    en: {
      properties: "Properties in portfolio",
      description: "Results by property. Select one to open its details.",
      forecast: "Including forecast",
      actual: "Current year to date",
    },
  }[language];

  return (
    <div className="border-t border-softiq-primary/10 bg-white/50 px-4 py-4 dark:border-white/10 dark:bg-softiq-dark-elevated sm:px-5 sm:py-5">
      <div className="mb-3 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="app-section-eyebrow">{copy.properties}</p>
          <p className="app-section-description mt-1">{copy.description}</p>
        </div>
        <span className="app-pill-property px-2.5 py-1 font-medium uppercase tracking-[0.12em] dark:text-softiq-secondary">
          {isPredictionView ? copy.forecast : copy.actual}
        </span>
      </div>

      <div className="grid gap-3 xl:grid-cols-2">
        {estates.map((estate) => (
          <PortfolioEstateCard
            key={estate.id}
            estate={estate}
            stats={estateStats[estate.id]}
            isPredictionView={isPredictionView}
            onSelect={() => onSelectEstate(estate)}
          />
        ))}
      </div>
    </div>
  );
}
